import { useContext, useEffect, useState } from 'react'
import { authContext } from 'contexts/AuthContext'
import allCompanyTabs from '../data/allCompanyTabs'

const useFilterTabs = () => {
  const { auth } = useContext(authContext)
  const [permission, setPermission] = useState(null)
  const [filteredTabs, setFilteredTabs] = useState()

  useEffect(() => {
    setPermission(auth?.data?.staff?.permissions?.map(({ id }) => id))
  }, [auth])

  useEffect(() => {
    setFilteredTabs(
      allCompanyTabs
        .map((item) => {
          if (permission?.includes(item?.permissionId)) {
            return item
          }
          return undefined
        })
        .filter((item) => item !== undefined)
    )
  }, [permission])

  return { filteredTabs }
}

export default useFilterTabs
